import {
  BUILDING_LIST_REQUESTED,
  DELETE_PMC_FAILURE,
  DELETE_PMC_REQUEST,
  DELETE_PMC_SUCCESS,
  GET_DOORS_FAILURE,
  GET_DOORS_REQUEST,
  GET_DOORS_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_PMCS_FAILURE,
  GET_PMCS_REQUEST,
  GET_PMCS_SUCCESS,
  GET_PMC_STAFF_FAILURE,
  GET_PMC_STAFF_REQUEST,
  GET_PMC_STAFF_SUCCESS,
  PMC_CREATE_FAILURE,
  PMC_CREATE_REQUESTED,
  PMC_CREATE_SUCCESS,
  PMC_LIST_REQUESTED,
  PMC_REQUESTED,
  PMC_UPDATE_FAILURE,
  PMC_UPDATE_REQUESTED,
  PMC_UPDATE_SUCCESS,
  SET_MODAL_TYPE,
} from '../../actionConstants';
import { getSRCategories } from '../ServiceRequest/actionCreators';

import { getTodayCount } from '../../utils';

import apiClient from '../../apiClient';
import { history } from '../../store';
import { CONFIRM } from '../Modal/modalTypes';

export const getAllPmcReducedData = (dispatch) => {
  dispatch({
    type: PMC_LIST_REQUESTED,
    payload: apiClient.pmc.allReducedData(),
  });
};

export const getPmcList = (dispatch) =>
  dispatch({
    type: PMC_LIST_REQUESTED,
    payload: apiClient.pmc.all({ disable_pagination: true }),
  });

export const getPMC = (dispatch, PMCId) => {
  dispatch({
    type: PMC_REQUESTED,
    payload: apiClient.pmc.get(PMCId),
  });
};

export const getPmcBuildings = (dispatch, PMCId) =>
  dispatch({
    type: BUILDING_LIST_REQUESTED,
    payload: apiClient.pmc.buildingsWithoutPagination(PMCId),
    PMCId,
  });

export const getPMCAndRelatedData = (dispatch, PMCId) => {
  getPmcBuildings(dispatch, PMCId);
  return getSRCategories(dispatch, PMCId);
};

export const getPMCStaff = (dispatch, queryParams, PMCId, isExport) =>
  dispatch({
    type: GET_PMC_STAFF_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.pmc.staff(PMCId, queryParams).then(
      (res) => {
        dispatch({
          type: isExport ? GET_ITEMS_FOR_EXPORT_SUCCESS : GET_PMC_STAFF_SUCCESS,
          res,
          PMCId,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_PMC_STAFF_FAILURE,
          err,
        }),
    ),
  });

export const getPMCs = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_PMCS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.pmc.all(queryParams).then(
      (res) => {
        dispatch({
          type: isExport ? GET_ITEMS_FOR_EXPORT_SUCCESS : GET_PMCS_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_PMCS_FAILURE,
          err,
        }),
    ),
  });

export const placeHolder = 'null';

export const createPMC = (dispatch, data) =>
  dispatch({
    type: PMC_CREATE_REQUESTED,
    isForm: true,
    payload: apiClient.pmc.create(data).then(
      () => {
        dispatch({
          type: PMC_CREATE_SUCCESS,
          successMessage: 'PMC successfully created',
        });
        return history.goBack();
      },
      (err) => {
        dispatch({
          type: PMC_CREATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const updatePMC = (dispatch, pmcId, data) =>
  dispatch({
    type: PMC_UPDATE_REQUESTED,
    isForm: true,
    payload: apiClient.pmc.update(pmcId, data).then(
      () => {
        dispatch({
          type: PMC_UPDATE_SUCCESS,
          successMessage: 'PMC successfully Updated',
        });
        getPMC(dispatch, pmcId);
      },
      (err) => {
        dispatch({
          type: PMC_UPDATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

const deletePMC = (dispatch, pmcId, queryParams) =>
  dispatch({
    type: DELETE_PMC_REQUEST,
    payload: apiClient.pmc.delete(pmcId).then(
      () => {
        dispatch({
          type: DELETE_PMC_SUCCESS,
          successMessage: 'PMC successfully deleted',
          id: pmcId,
        });
        getTodayCount(getPMCs, dispatch, queryParams);
        return getPMCs(dispatch, queryParams);
      },
      (err) =>
        dispatch({
          type: DELETE_PMC_FAILURE,
          err,
        }),
    ),
  });

export const onPmcDelete = (dispatch, PMC, listParams) => {
  const modalProps = {
    bodyText: `Are you sure you want to delete PMC "${PMC.name}"?`,
    onConfirm: () => deletePMC(dispatch, PMC.id, listParams),
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const getPmcDoors = (
  dispatch,
  params = {},
  pmcId,
  isExport,
  removePrev,
  updateDoors,
) => {
  const queryParams = { ...params, disable_pagination: true };
  return dispatch({
    type: GET_DOORS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.pmc.getDoors(pmcId, queryParams).then(
      (res) => {
        dispatch({
          type: isExport ? GET_ITEMS_FOR_EXPORT_SUCCESS : GET_DOORS_SUCCESS,
          removePrev,
          res,
        });
        updateDoors && updateDoors(res?.data);
        return { data: { results: res?.data } };
      },
      (err) =>
        dispatch({
          type: GET_DOORS_FAILURE,
          err,
        }),
    ),
  });
};
